import { FEATURE } from '~/common/enums/feature.enum';
import { LinkNew } from '~/domains/common/components/Link/Link';
import { Text } from '~/domains/design-system/Text';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';

interface RecaptchaTextProps {
  textAlign?: 'left' | 'center' | 'right';
}

export function RecaptchaText({ textAlign = 'center' }: RecaptchaTextProps) {
  const isRecaptchaEnabled = useIsFeatureEnabled(FEATURE.ENABLE_RECAPTCHA);

  if (!isRecaptchaEnabled) {
    return null;
  }

  return (
    <Text align={textAlign} /* eslint-disable-line local-rules/use-theme-tokens */ mt="16px" c="gray2.3" tag="div">
      This site is protected by reCAPTCHA and the Google{' '}
      <LinkNew href="https://policies.google.com/privacy">Privacy Policy</LinkNew> and{' '}
      <LinkNew href="https://policies.google.com/terms">Terms of Service</LinkNew> apply.
    </Text>
  );
}
